// WI#22 — the runner's LOCAL calendar day as YYYY-MM-DD. `toISOString()` is UTC, which after
// 5 PM Pacific is already tomorrow: check-ins were dated the next day and the heatmap drifted.
export function localDateStr(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

// Noon avoids DST edges when stepping whole days.
export function addLocalDays(date: Date, days: number): Date {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate() + days, 12);
  return d;
}
